import Cookies from 'js-cookie';

const STORAGE_KEY = 'zoomey_custom_context_limits';

export function getCustomContextLimits() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.enabled ? parsed : null;
  } catch {
    return null;
  }
}

export function saveCustomContextLimits(limits) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(limits));
  } catch {
    // localStorage not available
  }
}

export function getContextLimitsForPayload() {
  const limits = getCustomContextLimits();
  if (!limits || !limits.enabled) return undefined;
  const { enabled, ...rest } = limits;
  return Object.keys(rest).length > 0 ? rest : undefined;
}
